import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  IconButton,
  InputAdornment,
  Link,
  Stack,
  TextField,
} from "@mui/material";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import { signin } from "../../actions/Auth";
import TwoFactorStep from "../../twoFactor/TwoFactorStep";
import AuthShell from "../../ui/AuthShell";

const Login = () => {
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [busy, setBusy] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // Set when the password was right but the authenticator code is still due
  const [twoFactor, setTwoFactor] = useState(null);

  const handleOnSubmit = (e) => {
    e.preventDefault();
    setBusy(true);
    dispatch(signin(formData, navigate)).then((pending) => {
      setBusy(false);
      if (pending?.twoFactor) setTwoFactor(pending);
    });
  };
  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  if (twoFactor) {
    return (
      <AuthShell title="Log in">
        <Box sx={{ mt: 2, "& .tf-panel": { border: 0, padding: 0 } }}>
          <TwoFactorStep
          step={twoFactor.twoFactor}
          tempToken={twoFactor.tempToken}
          onDone={(data) => dispatch(signin(null, navigate, data))}
          onCancel={() => setTwoFactor(null)}
          />
        </Box>
      </AuthShell>
    );
  }

  return (
    <AuthShell title="Log in" subtitle="Use your bank apps email and password.">
      <Stack component="form" onSubmit={handleOnSubmit} gap={2.25}>
        <TextField
          name="email"
          label="Email address"
          type="email"
          autoComplete="email"
          autoFocus
          required
          fullWidth
          size="medium"
          value={formData.email}
          onChange={handleChange}
        />
        <TextField
          name="password"
          label="Password"
          type={showPassword ? "text" : "password"}
          autoComplete="current-password"
          required
          fullWidth
          size="medium"
          value={formData.password}
          onChange={handleChange}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={() => setShowPassword(!showPassword)}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                  edge="end"
                >
                  {showPassword ? <VisibilityOffOutlinedIcon /> : <VisibilityOutlinedIcon />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <Box sx={{ textAlign: "right", mt: -1 }}>
          <Link component={RouterLink} to="/insurance/resetPassword" variant="body2" underline="hover">
            Forgot password?
          </Link>
        </Box>
        <Button type="submit" variant="contained" size="large" disabled={busy}>
          {busy ? "Logging in..." : "Log in"}
        </Button>
      </Stack>
    </AuthShell>
  );
};

export default Login;
